/// <reference path="../classes/question.ts" />
module App.Interfaces {
    export interface IProduct {
        name: string;
        id: string;
        units: number;
        code: string;
        groupName: string;
        description: string;
        price: number;
        discountPrice: number;
        popupText: string;
        isReminderProduct: boolean;
        type: any;
        productExtraTextField: string;
        showProductTextField: boolean;
        noSaturday: boolean;
        customerWaiting: boolean;
        category: string;
        subCategory: string;
        question: Question;
        durationMinutes: number;
    }
}